import { render, staticRenderFns } from "./TableRowMenuItem.vue?vue&type=template&id=3e658ec0&scoped=true&"
import script from "./TableRowMenuItem.vue?vue&type=script&lang=js&"
export * from "./TableRowMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TableRowMenuItem.vue?vue&type=style&index=0&id=3e658ec0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e658ec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
